var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import Select from '@/common/components/Select/index.vue';
import { _post } from '@/common/request';
var ShopSelect = /** @class */ (function (_super) {
    __extends(ShopSelect, _super);
    function ShopSelect() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        /* data */
        _this.data = __spreadArrays(_this.status);
        _this.originOptions = []; // 原始数据
        _this.options = [];
        _this.timer = null;
        _this.selectedOptions = [];
        return _this;
    }
    ShopSelect.prototype.optionsChange = function () {
        var _this = this;
        this.$nextTick(function () {
            _this.$refs.shopSelect.setSelected();
        });
    };
    ShopSelect.prototype.mounted = function () {
        this.searchPlace('');
    };
    /* method */
    ShopSelect.prototype.searchPlace = function (keyword) {
        return __awaiter(this, void 0, void 0, function () {
            var _list, newData;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _list = this.originOptions;
                        if (!!(_list === null || _list === void 0 ? void 0 : _list.length)) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.getMetroSelect()];
                    case 1:
                        _a.sent(); // 请求接口数据
                        return [2 /*return*/];
                    case 2:
                        if (keyword) {
                            newData = _list.filter(function (item) {
                                return item.name.indexOf(keyword) > -1;
                            });
                        }
                        else {
                            newData = _list;
                        }
                        newData = this.concatObjArray(this.selectedOptions, newData);
                        this.options = newData;
                        return [2 /*return*/];
                }
            });
        });
    };
    // 获取所属线路数据
    ShopSelect.prototype.getMetroSelect = function () {
        var _this = this;
        var params = {
            'label': 'metroLineUsed'
        };
        _post('/resserv/api/dropDownList/enum/getGroup', params, { needHint: true, needCancel: false, needPrefix: false }).then(function (res) {
            _this.options = res;
            _this.originOptions = res;
        });
    };
    ShopSelect.prototype.concatObjArray = function (oldArr, newArr) {
        if (!oldArr || oldArr.length === 0)
            return newArr;
        var oldIds = oldArr.map(function (e) { return e.value; });
        return __spreadArrays(oldArr, newArr.filter(function (e) { return oldIds.indexOf(e.value) < 0; }));
    };
    ShopSelect.prototype.changeHandle = function (val) {
        if (val && val.length) {
            this.selectedOptions = this.options.filter(function (e) { return val.includes(e.value); });
        }
        else {
            this.selectedOptions = [];
        }
        this.$emit('update:status', this.data);
        this.$emit('change', this.data);
    };
    __decorate([
        Prop({ type: Array, default: function () { return []; } })
    ], ShopSelect.prototype, "status", void 0);
    __decorate([
        Watch('options', {
            deep: true
        })
    ], ShopSelect.prototype, "optionsChange", null);
    ShopSelect = __decorate([
        Component({
            components: {
                Select: Select,
            },
        })
    ], ShopSelect);
    return ShopSelect;
}(Vue));
export default ShopSelect;
